import { render, staticRenderFns } from "./PoloList.vue?vue&type=template&id=f38dfc82&scoped=true&"
import script from "./PoloList.vue?vue&type=script&lang=js&"
export * from "./PoloList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38dfc82",
  null
  
)

export default component.exports